import React, { useState, useEffect, useRef } from 'react';
import './TempMeasurement.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';

const config = require('../config');

const HeatPumpTargetSettings = ({ header, measurement,  setVillaFloorHeatingValue, selectedHeatingMode, showTempSettings }) => {
  const [minValue, setMinValue] = useState('');
  const [targetValue, setTargetValue] = useState('');
  const [maxValue, setMaxValue] = useState('');
  const [minValueError, setMinValueError] = useState('');
  const [targetValueError, setTargetValueError] = useState('');
  const [maxValueError, setMaxValueError] = useState('');

  const prevMinValue = useRef(minValue);
  const prevTargetValue = useRef(targetValue);
  const prevMaxValue = useRef(maxValue);

  useEffect(() => {
    if (showTempSettings) {
      const token = localStorage.getItem('token');
      
      if (selectedHeatingMode !== 'Manual') {
        fetch(config.serverUrl + '/villa-temp-settings?measurement=' + measurement + 'Settings&heating-mode=' + selectedHeatingMode,  {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          })
          .then(response => response.json())
          .then(data => {
            setMinValue(data.minValue ?? '');
            setTargetValue(data.targetValue ?? '');
            setMaxValue(data.maxValue ?? '');
          });
      }
      else {
        setMinValue('');
        setTargetValue('');
        setMaxValue('');
      }
    }
  }, [showTempSettings, selectedHeatingMode, measurement]);

  const handleBlur = async () => {
    const token = localStorage.getItem('token');

    if (selectedHeatingMode === 'Manual')
      return;
    
    try {
      const minValueNum = parseFloat(minValue);
      const targetValueNum = parseFloat(targetValue);
      const maxValueNum = parseFloat(maxValue);      

      let hasError = false;

      if (isNaN(minValueNum) && minValue !== null && minValue !== '') {
        setMinValueError('Invalid number');
        hasError = true;
      } else {
        setMinValueError('');
      }

      if (isNaN(targetValueNum) && targetValue !== null && targetValue !== '') {  
        setTargetValueError('Invalid number');
        hasError = true;
      } else {
        setTargetValueError('');
      }

      if (isNaN(maxValueNum) && maxValue !== null && maxValue !== '') { 
        setMaxValueError('Invalid number');
        hasError = true;
      } else {
        setMaxValueError('');
      }
      
      if (minValueNum > targetValueNum) {
        setMinValueError('Min value must be less than target value');
        hasError = true;
      }

      if (targetValueNum > maxValueNum) {
        setTargetValueError('Target value must be less than max value');
        hasError = true;
      }

      if (hasError) {
        return;
      }

      if (minValue !== prevMinValue.current || targetValue !== prevTargetValue.current || maxValue !== prevMaxValue.current) {
        await fetch(config.serverUrl + '/villa-temp-settings', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            measurement: measurement + 'Settings',
            heatingMode: selectedHeatingMode,
            minValue: minValue ?? '',
            targetValue: targetValue ?? '',
            maxValue: maxValue ?? ''
          })
        });
        prevMinValue.current = minValue;
        prevTargetValue.current = targetValue;
        prevMaxValue.current = maxValue;
      }
    } catch (error) {
      console.error('Error updating temperature settings:', error);
    }
  };

  const handleMinValueChange = (e) => setMinValue(e.target.value);
  const handleTargetValueChange = (e) => setTargetValue(e.target.value);
  const handleMaxValueChange = (e) => setMaxValue(e.target.value);

  return (
    <div className="input-container">
      <span className="header">{header}</span>      
      <input type="text" value='' readOnly className='input-field' />
      <button className='graph-btn'>
        <FontAwesomeIcon icon={faChartLine} />
      </button>
      {showTempSettings &&
        <>
          <input type="text" placeholder="min" value={minValue ?? ''} onChange={handleMinValueChange} onBlur={handleBlur} className={`temp-measurement-input-field ${minValueError ? 'temp-measurement-error-input' : ''}`} data-error={minValueError}/>
          <input type="text" placeholder="target" value={targetValue ?? ''} onChange={handleTargetValueChange} onBlur={handleBlur} className={`temp-measurement-input-field ${targetValueError ? 'temp-measurement-error-input' : ''}`} data-error={targetValueError}/>
          <input type="text" placeholder="max" value={maxValue ?? ''} onChange={handleMaxValueChange} onBlur={handleBlur} className={`temp-measurement-input-field ${maxValueError ? 'temp-measurement-error-input' : ''}`} data-error={maxValueError}/>
        </>
      }      
    </div>
  );
};

export default HeatPumpTargetSettings;
